// api/client.ts
import axios from 'axios';

const apiClient = axios.create({
    baseURL: 'https://api.artfield.app/api', // Your API base URL
    headers: {
        'Content-Type': 'application/json'
    }
});

export default apiClient;
